<title>{{ KnownIssuesPage.htmlTitle }}</title>
<app-banner [banner]="KnownIssuesPage.banner" [isCommonBanner]="true" [isDefaultPageBanner]="false"></app-banner>

<div class="d-flex container-fluid p-0 apiContainer" id="wrapper">
    <div class="container mt-5 mb-5 minheight">
        <app-known-issues-details-page *ngIf="showDetailsPage" [item]="selectedItem" (back)="onBack()">
        </app-known-issues-details-page>
        <div *ngIf="!showDetailsPage">
            <h3>All Known Issues</h3>

            <div class="CommonTable knownIssueTable" id="your-container-id">
                <table *ngIf="items.length > 0">
                    <thead>
                        <tr>
                            <th>Title</th>

                            <th>Service Name</th>

                            <th>Error Message</th>
                            <th>Issue Number</th>
                            <th>Production date</th>
                            <th>Status</th>
                            <th>Last Updated</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of items">
                            <td>{{ item.summary }}</td>
                            <td>{{ item.apiName }}</td>
                            <td>
                                {{ displayErrorMsg(item.errorMsg) }}
                            </td>
                            <td>
                                <a href="#" (click)="onSelectItem($event, item)">{{ item?.key }}</a>
                            </td>

                            <td>
                                <ng-container
                                    *ngIf="item.productionDate && item.productionDate !== 'null'; else checkCondition">
                                    {{ item.productionDate | date:'dd-MM-yyyy' }}
                                </ng-container>
                                <ng-template #checkCondition>
                                    <ng-container *ngIf="item.plannedQuarter ; else displayTBC">
                                        {{ item.plannedQuarter }}
                                    </ng-container>
                                </ng-template>
                                <ng-template #displayTBC>
                                    TBC
                                </ng-template>
                            </td>
                            <td>
                                <ng-container *ngIf="item.status !== 'null'">{{ item.status }}</ng-container>
                            </td>
                            <td>{{ item.updated | date:'dd-MM-yyyy'}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <ng-template [ngIf]="subscribeUrl">
                <div class="subscribeLink">
                    <button class="subscribeMe">
                        <i class="fa fa-envelope"></i>
                        <a [href]="subscribeUrl">Subscribe Notifications</a>
                    </button>
                </div>
            </ng-template>
        </div>
    </div>
</div>